import axios from 'axios';
import { currentHttpOptions } from '../../../../common/utilities/utilitiesFunctions';

const API_URL = 'api/v1/manager/Workplan';
/**
 * @param {Date} date
 * @returns {Promise<ApiManager.GetLocationsResponse>}
 */
export const getLocations = (date) => {
    return axios.get(`${process.env.REACT_APP_DOTNET_URL}/${API_URL}/GetLocations?date=${date}`, currentHttpOptions())
}
